export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              大家都在讨论的影视热点，加入话题一起聊
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #星际征途彩蛋解析
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">128万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #暗夜追踪结局猜测
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">96万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #大唐风华服化道
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">215万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #恋之樱花季OST
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">83万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #深海危机拍摄揭秘
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">67万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #暑期档必看清单
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">342万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #国产科幻崛起
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">178万讨论</span>
            </a>
            <a href="#media" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #蓝光vs流媒体画质
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">54万讨论</span>
            </a>
            <a href="#ranking" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #本周热播榜变化
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">89万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #纪录片推荐清单
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">41万讨论</span>
            </a>
            <a href="#cards" className="group px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #西瓜影视新功能
              </span>
              <span className="ml-2 text-xs text-foreground-400 whitespace-nowrap">156万讨论</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}